<template>
  <div>
		<div class="vx-row">
			<vx-card title="Add Device Mapping" class="mb-4 pb-5">
				<!-- aino merchant -->
				<div class="w-full flex flex-no-wrap">
					<div class="w-1/6 p-5">
						<span>Aino Merchant</span>
					</div>
				<div class="w-5/6 p-4">
           			 <v-select 
						v-model="merchant"
						placeholder="Select merchant"
						:options="merchants"
						v-validate="'required'"
						name="Merchant"
					></v-select>
				<span class="text-danger text-sm" v-show="errors.has('Merchant')">{{ errors.first('Merchant') }}</span>
         		</div>
				</div>
				<!-- aino device -->
				<div class="w-full flex flex-no-wrap">
					<div class="w-1/6 p-5">
						<span>Aino Device</span>
					</div>
					<div class="w-5/6 p-4">
            			<v-select 
							v-model="device" 
							placeholder="Select device" 
							:options="devices" 
							:disabled="merchant == '' || merchant == null"
							v-validate="'required'"
							name="Device Code"
						></v-select>
						<span class="text-danger text-sm" v-show="errors.has('Device Code')">{{ errors.first('Device Code') }}</span>
					</div>
				</div>

				<!-- PTO Merchant  -->
				<div class="w-full flex flex-no-wrap">
					<div class="w-1/6 p-5">
						<span>PTO Name</span>
					</div>
					<div class="w-5/6 p-4">
           				<v-select 
						   	v-model="pto"
							placeholder="Select PTO Name"
							:options="ptoList"
							v-validate="'required'"
							name="PTO Name"
							:disabled="device == ''"
						></v-select>
						<span class="text-danger text-sm" v-show="errors.has('PTO Name')">{{ errors.first('PTO Name') }}</span>
          			</div>
				</div>

				<!-- pto merchant code -->
				<div class="w-full flex flex-no-wrap">
					<div class="w-1/6 p-5">
						<span>PTO Merchant ID</span>
					</div>
					<div class="w-5/6 p-4">
						<vs-input 
							class="w-full" 
							v-model.trim="ptoMerchantId" 
							placeholder="Fill PTO merchant ID" 
							v-validate="'required'"
							name="PTO Merchant ID"
							@input="(val) => (ptoMerchantId = ptoMerchantId.toUpperCase())"
							:disabled="pto == ''" 
						/>
						<span class="text-danger text-sm" v-show="errors.has('PTO Merchant ID')">{{ errors.first('PTO Merchant ID') }}</span>
					</div>
				</div>

				<!-- pto device code -->
				<div class="w-full flex flex-no-wrap">
					<div class="w-1/6 p-5">
						<span>PTO Device Code</span>
					</div>
					<div class="w-5/6 p-4">
						<vs-input 
							class="w-full"
							v-model.trim="ptoDeviceCode"
							placeholder="Fill PTO device code"
							v-validate="'required'"
							name="PTO Device Code"
							@input="(val) => (ptoDeviceCode = ptoDeviceCode.toUpperCase())"
							:disabled="ptoMerchantId == ''"
						/>
						<span class="text-danger text-sm" v-show="errors.has('PTO Device Code')">{{ errors.first('PTO Device Code') }}</span>
					</div>
				</div>

				<!-- action button -->
				<div class="w-full text-right p-4">
					<vs-button id="btn-cancel" color="warning" @click="backPage">Cancel</vs-button>
					<vs-button id="btn-submit" class="ml-4" @click.prevent="showConfirmDialog">Submit</vs-button>
					<vs-popup title="Are you sure with this data?" :active.sync="popupActivo">
						Merchant Name: <b>{{this.merchant.merchantName}}</b><br />
						Device Code: <b>{{this.device.deviceCode || ""}}</b><br />
						PTO Name: <b>{{this.pto.label || ""}}</b><br />
						PTO Merchant ID: <b>{{this.ptoMerchantId || ""}}</b><br />
						PTO Device Code: <b>{{this.ptoDeviceCode || ""}}</b><br />
						<div class="w-full text-right">
								<vs-button id="btn-submit" class="mt-5 ml-4" @click.prevent="submitForm">Submit</vs-button>
						</div>
					</vs-popup>
      			</div>
			</vx-card>
		</div>
  </div>
	
</template>

<script>
import vSelect from 'vue-select'
import AxiosCall from "@/global/AxiosCall";
import { url } from "@/configs/apiUrl";
export default {
	name: "AddDeviceMapping",
  components: {
    'v-select': vSelect,
  },
	data() {
		return {
			merchant: '',
			merchants: [],
			pto: '',
			ptoList: [
				{
					id: 1,
					label: "KCI"
				},
				{
					id: 2,
					label: "TransJakarta"
				},
				{
					id: 3,
					label: "MRT"
				},
				{
					id: 4,
					label: 'LRT'
				},
				{
					id: 5,
					label: "Railink",
				}
			],
			device: '',
			devices: [],
			ptoMerchantId: '',
			ptoDeviceCode: '',
			popupActivo: false,
		};
	},
	watch: {
		//update merchant value
		merchant: function(merchant) {
			if (merchant != null && merchant != '') {
				let merchantId = merchant.id
				AxiosCall.Get(url.svd.device.combo + '?merchant_id=' + merchantId)
					.then((res) => {
						this.device = '';
						this.devices = [];
						for(let data of res.data) {
							data.label = data.name + ' - ' + data.code + ' - ' + data.merchant_full_name;
							data.deviceCode =  data.code
							this.devices.push(data)
						}
					}, (err) => {
						console.error(err)
				})
			}else {
				this.device = '';
				this.merchant = '';
			}
		},
		//update device value
		device: function(device) {
			if(device == '' || device == null) {
				this.pto = '';
				this.device = '';
			}
		},
		pto: function(pto) {
			if(pto == '' || pto == null) {
				this.ptoMerchantId = '';
				this.pto = '';
			}
		},
		ptoMerchantId: function(value) {
			if(value == '') {
				this.ptoDeviceCode = '';
			}
		}
	},
	methods : {
		//error notify
		danger(title, text) {
			this.$vs.notify({
				title: title,
				text: text,
				color: "danger",
				position: "top-right"
			});
		},
		backPage() {
			this.$router.push({ path: '/device/mapping'});
		},
		showConfirmDialog() {
			this.$validator.validateAll()
				.then((res) => {
					if(res) {
						this.popupActivo = true;
					}
				})
		},
		submitForm() {
			this.$validator.validateAll()
				.then((res) => {
					if(res) {
						this.popupActivo = false;
						let payload = {
							aino_merchant_id: this.merchant.id,
							aino_device_code: this.device.code,
							pto_id: this.pto.id,
							pto_merchant_id: this.ptoMerchantId,
							pto_device_code: this.ptoDeviceCode,
						}
						AxiosCall.Post(url.svd.device_mapping.store, payload)
							.then((res) => {
								if(res.code == 200) {
									this.$store.dispatch('createAuditTrail', {
                    user_id:    JSON.parse(localStorage.getItem('userInfo')).id,
                    session_id: parseInt(localStorage.getItem('sessID')),
                    user_name:  JSON.parse(localStorage.getItem('userInfo')).displayName,
                    menu:      "Device Mapping",
                    activity: "Add device mapping",
                    data_before: {},
                    data_after: payload,
                  })
                  let status = true;
									this.$router.push({name: "DeviceMapping", params: { status: status, message: "Add device mapping success"} });
								}
							}, (error) => {
								this.$vs.notify(error.response.data.notify)
							})
					}
				}, (err) => {
					console.log(err)
				})
		},
	},
	mounted() {
		let merchant = JSON.parse(localStorage.getItem('userInfo')).merchant;
		// check merchant id if exists
		let merchantid = (merchant.id !== undefined) ? merchant.id : (merchant.parent_id !== undefined) ? merchant.parent_id : '';

		// get merchants
		AxiosCall.Get(url.svd.merchant.list_by_parent_id + '/' + merchantid)
			.then((res) => {
				this.merchant = '';
				this.merchants = [];
				for(let data of res.data) {
					let depth = ' - '
					data.label = depth.repeat(data.depth) + data.full_name;
					data.merchantName = data.full_name;
					this.merchants.push(data)
				}
			}, (err) => {
				console.error(err)
			}); 
	},
}
</script>

<style>
.con-vs-popup .vs-popup {
  width: 400px !important;
  height: auto !important;
}

</style>